import { create } from "zustand"
import { persist } from "zustand/middleware"

interface PermState {
  emulateUserId: string | undefined
  setPermStore: (data: Partial<Omit<PermState, "setPermStore">>) => void
}

export const usePermStore = create<PermState>()(
  persist(
    (set) => ({
      emulateUserId: undefined,
      setPermStore: set,
    }),
    { name: "permStore" }
  )
)
